import { Mtn } from "assets/images";
import { Button } from "components";
import React from "react";

const MoMoPsb = () => {
  return (
    <div
      className={`h-[236px] bg-[#F1F1F1] shadow-md flex flex-col justify-center px-6`}
    >
      <div className="flex flex-col gap-7">
        <div className="flex items-center space-x-2">
          <Mtn className="w-10 h-10" />
          <p className="">MoMo PSB</p>
        </div>
        <div className="flex flex-col gap-6">
          <p className="font-bold text-[#0D121D]">
            To accept payments, you need to connect an existing MoMo PSB account
            or create a new one to access Buy Button in your Flows.
          </p>

          <div className="w-[400px]">
            <Button>Connect MoMo PSB Account</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoMoPsb;
